<div class="toggleContainer" [class.readonly]="readonly">
  <input
    class="toggleInput"
    type="checkbox"
    [attr.checked]="value ? 'checked' : null"
    [id]="id ?? labelId"
    #inputRef
  />
  <label class="toggleLabel" (click)="toggleValue()">
    <span class="toggleSlider"></span>
  </label>
  <input type="hidden" [formControl]="control" />
</div>
<div class="text-label" *ngIf="label?.trim().length">
  <span (click)="toggleValue()">{{label}} <small *ngIf="!!label && canShowRequiredLabel()">(Required)</small></span>
  <app-dc-popover
      *ngIf="helpText?.trim().length"
      [body]="helpText"
      [class.helpText]="helpText"
      [autoClose]="2000"
    ></app-dc-popover>
</div>
